module.exports = __webpack_public_path__ + "img/FY25_JMSA_SpringPassSales_WebBanner-960-246.jpg";